import { formatDateTime } from './utils.mjs';

export default function DateTimeP({ dateTimeOverride, startDate, endDate, startTime, endTime }) {
  let dateTime = '';

  if (dateTimeOverride) {
    dateTime = dateTimeOverride;
  } else {
    dateTime = formatDateTime(startDate, endDate, startTime, endTime);
  }

  return (
    <p className="label-3">
      {dateTime}
    </p>
  );
}
